/**
 * Animated pill controller for groove-shared-pagination Swiper bullets.
 * @param {HTMLElement|null} paginationEl
 * @param {{ pillWidth?: number, useBoundingRect?: boolean, bulletSize?: number }} [options]
 * @returns {{ create: () => void, move: (index: number, animate?: boolean) => void, reset: () => void }}
 */
function createGroovePaginationPill(paginationEl, options = {}) {
  const pillWidth = options.pillWidth ?? 10;
  const useBoundingRect = options.useBoundingRect ?? false;
  const bulletSize = options.bulletSize ?? pillWidth;
  let pillEl = null;
  let prevIndex = 0;

  function getBulletLeft(bullet) {
    if (!paginationEl || !bullet) return 0;

    if (useBoundingRect) {
      const rootRect = paginationEl.getBoundingClientRect();
      const bulletRect = bullet.getBoundingClientRect();
      return bulletRect.left - rootRect.left + (bulletSize - pillWidth) / 2;
    }

    return bullet.offsetLeft + (bullet.offsetWidth - pillWidth) / 2;
  }

  return {
    create() {
      if (!paginationEl) return;

      pillEl = paginationEl.querySelector('.groove-bullet-slider');
      if (pillEl) return;

      pillEl = document.createElement('span');
      pillEl.className = 'groove-bullet-slider';
      pillEl.setAttribute('aria-hidden', 'true');
      paginationEl.appendChild(pillEl);
    },

    move(index, animate = false) {
      if (!pillEl || !paginationEl) return;

      const bullets = paginationEl.querySelectorAll('.groove-bullet');
      const bullet = bullets[index];
      if (!bullet) return;

      const toLeft = getBulletLeft(bullet);

      if (!animate || index === prevIndex) {
        pillEl.style.transition = 'none';
        pillEl.style.left = `${toLeft}px`;
        pillEl.style.width = `${pillWidth}px`;
        pillEl.offsetHeight;
        pillEl.style.transition = '';
        prevIndex = index;
        return;
      }

      const fromBullet = bullets[prevIndex];
      if (!fromBullet) return;

      const fromLeft = getBulletLeft(fromBullet);
      const goingRight = index > prevIndex;

      if (goingRight) {
        pillEl.style.transition = 'width 0.22s ease-out, left 0.22s ease-out';
        pillEl.style.left = `${fromLeft}px`;
        pillEl.style.width = `${toLeft - fromLeft + pillWidth}px`;
      } else {
        pillEl.style.transition = 'width 0.22s ease-out, left 0.22s ease-out';
        pillEl.style.left = `${toLeft}px`;
        pillEl.style.width = `${fromLeft - toLeft + pillWidth}px`;
      }

      setTimeout(() => {
        pillEl.style.transition =
          'width 0.4s cubic-bezier(0.65, 0, 0.35, 1), left 0.4s cubic-bezier(0.65, 0, 0.35, 1)';
        pillEl.style.left = `${toLeft}px`;
        pillEl.style.width = `${pillWidth}px`;
      }, 200);

      prevIndex = index;
    },

    reset() {
      pillEl = null;
      prevIndex = 0;
    },
  };
}
